import { useEffect, useState } from 'react';
import QRScan from '../../components/qr_scan';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '../../hook/useQuery';
import Cookies from 'js-cookie';
import axios from 'axios';
import CONFIG from '../../constanta/config';
import helper from '../../utils/helper';

const PageListMenu = (props) => {
  const query = useQuery();
  const [event, setEvent] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (Cookies.get('token') === undefined) {
      navigate('/');
    }
    getGate();
  }, []);

  const logout = () => {
    Cookies.remove('token');
    window.location.href = './login';
  };

  const getGate = () => {
    axios
      .get(CONFIG.URL + '/event/gate', {
        headers: {
          token: Cookies.get('token')
        }
      })
      .then(function (response) {
        if (response?.data.status === 'SUCCESS') {

          // fungsi ambil angka dari string (Day 1 -> 1)
const getNumber = (str) => {
  const match = str.match(/\d+/);
  return match ? parseInt(match[0]) : 999;
};

// fungsi prioritas
const getPriority = (gate) => {
  if (gate.startsWith("Day")) return 1;
  if (gate.startsWith("Lunch")) return 2;
  return 3; // Awards atau lainnya
};

response?.data?.data?.sort((a, b) => {
  const priorityA = getPriority(a.gate);
  const priorityB = getPriority(b.gate);

  if (priorityA !== priorityB) {
    return priorityA - priorityB;
  }

  return getNumber(a.gate) - getNumber(b.gate);
});


          setEvent(response.data?.data);
        } else {
        }
      })
      .catch(function (error) {});
  };

  return (
    <>
      <div
        className="w-full min-h-screen flex flex-col justify-start items-center pt-10 bg-gray-200 px-5 bg-cover bg-no-repeat"
        style={{
          backgroundPosition: 'center',
          backgroundImage: `url('${helper.getBackground(
            props?.config?.background
          )}')`
        }}>
        <div className="flex flex-col justify-center items-center md:pb-20">
          <div className="grid grid-cols-1 gap-4  md:grid-cols-3 md:gap-6 bg-white p-10 rounded-lg shadow-lg">
            {event.map((v, index) => {
              return (
                <div key={index} className="flex flex-col space-y-2">
                  <div className="text-center uppercase text-black font-bold text-2xl mb-2">
                    {v.gate}
                  </div>
                  <a
                    key={index}
                    href={`./checkin?id_gate=${v.id_gate}&gate=${v.gate}`}
                    className={`uppercase min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-blue-500 w-full text-center`}>
                    Checkin
                  </a>

                  <a
                    href={`./checkout?id_gate=${v.id_gate}&gate=${v.gate}`}
                    className={`uppercase min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-red-500 w-full text-center`}>
                    Checkout
                  </a>
                </div>
              );
            })}

<div className="flex flex-col space-y-2">
                  <div className="text-center uppercase text-black font-bold text-2xl mb-2">
                   SURVEY
                  </div>
                  <a
                    href={`./survey?day=1&id_gate=1`}
                    className={`uppercase min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-purple-500 w-full text-center`}>
                    SURVEY DAY 1
                  </a>
                  <a
                     href={`./survey?day=2&id_gate=3`}
                    className={`uppercase min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-amber-500 w-full text-center`}>
                    SURVEY DAY 2
                  </a>
                  <a
                     href={`./survey?day=3&id_gate=5`}
                    className={`uppercase min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-green-500 w-full text-center`}>
                    SURVEY DAY 3
                  </a>


                </div>




{/*
            <div className="w-full">
              <div className="border border-white my-5"></div>
            </div> */}
          </div>

          {/* <div>
            <a
              href={`/checkout?id_gate=1`}
              className={`min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-blue-500 w-full text-center`}>
              CHECK OUT
            </a>
          </div> */}

          <button
            onClick={() => logout()}
            className={`mt-10 min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-red-500 w-full text-center`}>
            LOGOUT
          </button>
        </div>
      </div>
    </>
  );
};

export default PageListMenu;
